import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const MODULES = {
  toolbar: [
    [{ header: [2, 3, 4, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'blockquote'],
    ['clean'],
  ],
};

const FORMATS = ['header', 'bold', 'italic', 'underline', 'list', 'link', 'blockquote'];

// WYSIWYG editor that reads/writes an HTML string (maps to product/collection
// descriptionHtml, i.e. exactly what renders on the storefront).
export const RichTextEditor = ({ value, onChange, placeholder, testId }) => (
  <div className="rich-text-editor bg-white text-neutral-900" data-testid={testId}>
    <ReactQuill
      theme="snow"
      value={value || ''}
      onChange={(html) => onChange(html === '<p><br></p>' ? '' : html)}
      modules={MODULES}
      formats={FORMATS}
      placeholder={placeholder}
    />
  </div>
);

export default RichTextEditor;
